module.exports = __webpack_public_path__ + "static/media/project23.7e596509.jpg";